// EQUODRESINDV----------GP--	Dressage Individual Grand Prix
// EQUODRESINDV----------GPFR	Dressage Individual Grand Prix Freestyle
    
// EQUODRESTEAM----------GP--	Dressage Team Grand Prix
// EQUODRESTEAM----------GPSP	Dressage Team Grand Prix Special
    
// EQUOEVENINDV----------DRSS	Eventing Individual Dressage
// EQUOEVENINDV----------XC--	Eventing Individual Cross Country
// EQUOEVENINDV----------JUMP	Eventing Individual Jumping
    
// EQUOEVENTEAM----------DRSS	Eventing Team Dressage
// EQUOEVENTEAM----------XC--	Eventing Team Cross Country
// EQUOEVENTEAM----------JUMP	Eventing Team Jumping Final
    
// EQUOJUMPINDV----------QUAL	Jumping Individual Qualifier
// EQUOJUMPINDV----------FNL-	Jumping Individual Final
    
// EQUOJUMPTEAM----------QUAL	Jumping Team Qualifier
// EQUOJUMPTEAM----------FNL-	Jumping Team Final


// **** JUMPING ****
const JUMP_INDIV_QUAL = /EQUOJUMPINDV----------QUAL.+/
const JUMP_INDIV_JUMP_OFF = /EQUOJUMPINDV----------........RR.+/
const JUMP_INDIV = /EQUOJUMPINDV.+/
const JUMP_TEAM = /EQUOJUMPTEAM.+/
const JUMP_TEAM_QUAL = /EQUOJUMPTEAM----------QUAL.+/

export const isJumpingIndividualQual = (rsc) => {
    return JUMP_INDIV_QUAL.test(rsc);
}
export const isJumpingIndividualJumpOff = (rsc) => {
    return JUMP_INDIV_JUMP_OFF.test(rsc);
}
export const isJumpingIndividual = (rsc) => {
    return JUMP_INDIV.test(rsc);
}

export const isJumpingTeam = (rsc) => {
    return JUMP_TEAM.test(rsc);
}
export const isJumpingTeamQual = (rsc) => {
    return JUMP_TEAM_QUAL.test(rsc);
}


// **** DRESSAGE ****
const DRESSAGE_INDIVIDUAL = /EQUODRESINDV.+/
const DRESSAGE_INDIVIDUAL_GROUP_UNIT = /EQUODRESINDV----------GP--00..00--/
const DRESSAGE_GRAND_PRIX_QUALIFIER_DAY = /EQUODRES--------------COMP0001D.--/
export const DRESSAGE_INDIVIDUAL_GROUP_PHASE = 'EQUODRESINDV----------GP--';
export const DRESSAGE_TEAM_GRAND_PRIX = 'EQUODRESTEAM----------GP----------';
const DRESSAGE_GRAND_PRIX_QUALIFIER = /EQUODRESINDV----------GP--/;
const DRESSAGE_GRAND_PRIX_FREESTYLE = /EQUODRESINDV----------GPFR/;



export const isDressageIndividual = (rsc) => {
    return DRESSAGE_INDIVIDUAL.test(rsc);
}

export const isDressageIndividualGroupUnit = (rsc) => {
    return DRESSAGE_INDIVIDUAL_GROUP_UNIT.test(rsc);
}

export const isDressageGrandPrixQualifierDay = (rsc) => {
    return DRESSAGE_GRAND_PRIX_QUALIFIER_DAY.test(rsc) || DRESSAGE_GRAND_PRIX_QUALIFIER.test(rsc);
}

export const isDressageGranPrixFreestyle = (rsc) => {
    return DRESSAGE_GRAND_PRIX_FREESTYLE.test(rsc);
}

